import {
  logout,
  login
} from '@/api/login'
import {
  getUserInfo
} from '@/api/login'
import {
  getToken,
  setToken,
  removeToken,
  removeRefreshtoken,
  // getLang,
  // setLang,
  setRefreshToken,
  getRefreshToken,
  getProject,
  setObject
} from '@/utils/auth'
import router from '@/router/routers'
const user = {
  state: {
    token: getToken(),
    refreshToken: getRefreshToken(),
    tokenstate: 1,
    refreshtokenstate: 0,
    user: {},
    roles: [],
    loadMenus: false,
    language: '',
    theme: ''
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_REFRESHTOKEN: (state, refreshToken) => {
      state.refreshtoken = refreshToken
    },
    SET_TOKENSTATE: (state, tokenstate) => {
      state.tokenstate = tokenstate
    },
    SET_REFRESHTOKENSTATE: (state, refreshtokenstate) => {
      state.refreshtokenstate = refreshtokenstate
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_LOAD_MENUS: (state, loadMenusstate) => {
      state.loadMenus = loadMenusstate
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
    },
    SET_PROJECT: (state, project) => {
      state.project = project
    },
    SET_THEME: (state, theme) => {
      state.theme = theme
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
  },
  actions: {
    // 登录
    Login({
      commit,
      dispatch
    }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          if (res.code == 200) {
            console.log();
            if (getProject()) {
              commit('SET_PROJECT', getProject())
            }
            // else {
            //   console.log(888);
            //   commit('SET_PROJECT', 0)
            //   localStorage.setItem('project', 0)
            // }
            commit('SET_TOKEN', res.datas.token)
            commit('SET_REFRESHTOKEN', res.datas.refreshToken)
            commit('SET_TOKENSTATE', 0)
            setToken(res.datas.token)
            setRefreshToken(res.datas.refreshToken)
            // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
            commit('SET_LOAD_MENUS', true)
            dispatch('GetInfo')
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 刷新token
    refreshtoken({
      commit,
    }, refreshitem) {
      return new Promise((resolve, reject) => {
        login(refreshitem).then(res => {
          let invalid = false
          if (res.msg.includes("Invalid refresh token") && invalid == false) {
            removeToken()
            removeRefreshtoken()
            router.push({
              path: "/login"
            })
            invalid = true
          }
          if (invalid == false) {
            commit('SET_REFRESHTOKENSTATE', 0)
            commit('SET_TOKEN', res.datas.token)
            commit('SET_REFRESHTOKEN', res.datas.refreshToken)
            commit('SET_TOKENSTATE', 0)
            setToken(res.datas.token)
            setRefreshToken(res.datas.refreshToken)
            resolve(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // token状态
    tokenstate({
      commit
    }, tokenstate) {
      commit('SET_TOKENSTATE', tokenstate)
    },
    // 更新菜单
    updateLoadMenus({
      commit
    }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_MENUS', false)
      })
    },
    // 获取用户信息
    GetInfo({
      commit,
      dispatch
    }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          console.log(res, 99988888);
          commit('SET_TOKENSTATE', 0)
          setUserInfo(res, commit)
          let arr = []
          // if (!getProject()) {

          // }
          res.datas.projectVos.forEach(item => {
            arr.push(item.id)
          })
          console.log(!getProject(), arr.indexOf(Number(getProject())) == -1, arr, getProject());
          if (!getProject() || arr.indexOf(Number(getProject())) == -1) {
            commit('SET_PROJECT', res.datas.projectVos[0].id)
            localStorage.setItem('project', res.datas.projectVos[0].id)
            console.log(222, res.datas.projectVos[0].id);
          }
          // console.log(localStorage.getItem("isFirst"), "ee");
          if (localStorage.getItem("isFirst") == null) {
            localStorage.setItem("isFirst", true)
          }
          if (localStorage.getItem("isFirst1") == null) {
            localStorage.setItem("isFirst1", true)
          }
          if (localStorage.getItem("isFirst2") == null) {
            localStorage.setItem("isFirst2", true)
          }
          if (localStorage.getItem("isFirst3") == null) {
            localStorage.setItem("isFirst3", true)
          }
          if (localStorage.getItem("isFirst4") == null) {
            localStorage.setItem("isFirst4", true)
          }
          if (localStorage.getItem("isFirst5") == null) {
            localStorage.setItem("isFirst5", true)
          }
          if (localStorage.getItem("isFirst6") == null) {
            localStorage.setItem("isFirst6", true)
          }
          if (localStorage.getItem("isFirst7") == null) {
            localStorage.setItem("isFirst7", true)
          }
          resolve(res)
          if (res.code != 200) {
            commit('SET_REFRESHTOKENSTATE', 1)
            const Loginform = {}
            Loginform.clientId = "web"
            Loginform.clientSecret = 654321
            Loginform.refreshToken = getRefreshToken()
            Loginform.grantType = "refresh_token"
            dispatch('refreshtoken', Loginform)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({
      commit
    }) {
      const params = {}
      params.accessToken = getToken()
      return new Promise((resolve, reject) => {
        logout(params).then(res => {
          logOut(commit)
          resolve(res)
        }).catch(error => {
          logOut(commit)
          reject(error)
        })
      })
    },
    // 语言设置
    setLanguage({
      commit
    }, language) {
      commit('SET_LANGUAGE', language)
    },
    setTheme({
      commit
    }, theme) {
      commit('SET_THEME', theme)
    }
  },
}
export const logOut = (commit) => {
  commit('SET_TOKEN', '')
  commit('SET_ROLES', [])
  removeToken()
  removeRefreshtoken()
}
export const setUserInfo = (res, commit) => {
  // 如果没有任何权限，则赋予一个默认的权限，避免请求死循环
  if (res.datas.permission.length === 0) {
    commit('SET_ROLES', ['ROLE_SYSTEM_DEFAULT'])
  } else {
    commit('SET_ROLES', res.datas.permission)
  }
  commit('SET_USER', res.datas)
}
export default user